import { IconPencil, IconTrash } from '@tabler/icons-react';
import { useT } from '@hana/i18n';
import './screens.i18n';
import { useToast } from '@hana/ui';
import { buildOrgList, type OrgCell, type OrgListKey } from './orgCatalog';
import type { OrgBlock } from './types';
import s from './hr.module.css';

// Mint-HR · tab Cơ cấu & ghế › Phòng ban / Chức danh / Bậc (code board khối `orgList`). Chỉ đọc; Sửa / Xoá báo toast.

const TONE: Record<NonNullable<OrgCell['tone']>, string> = { link: s.olLink ?? '', warn: s.warn ?? '', mute: s.noteTd ?? '' };

export function HrOrgList({ view, blocks }: { view: OrgListKey; blocks: readonly OrgBlock[] }) {
  const t = useT();
  const toast = useToast();
  const { cols, rows, note } = buildOrgList(view, blocks);
  const noWrite = () => toast({ msg: t('hr.s.noWrite') });
  const label = view === 'dept' ? 'Phòng ban' : view === 'title' ? 'Chức danh' : 'Bậc';
  return (
    <section className={s.card} aria-label={label}>
      <table className={s.table}>
        <colgroup>
          {cols.map(([k, w]) => <col key={k} style={{ width: w }} />)}
          <col style={{ width: '168px' }} />
        </colgroup>
        <thead>
          <tr>
            {cols.map(([k]) => <th key={k} scope="col">{k}</th>)}
            <th aria-hidden="true" />
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.key}>
              {r.cells.map((c, i) => (
                <td key={i} className={`${s.olCell} ${c.tone ? TONE[c.tone] : ''}`} style={{ fontWeight: c.strong ? 600 : 450 }}>{c.v}</td>
              ))}
              <td className={s.right}>
                <div className={s.olAct}>
                  <button type="button" className={s.olEdit} onClick={noWrite}><IconPencil size={16} stroke={1.8} aria-hidden="true" />{t('hr.s.edit')}</button>
                  {view !== 'level' && (
                    <button type="button" className={`${s.olDel} ${r.delTone === 'err' ? s.olDelErr : ''}`} title={r.delTip} onClick={noWrite}>
                      <IconTrash size={16} stroke={1.8} aria-hidden="true" />{t('hr.s.del')}
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className={s.olNote}>{note}</div>
    </section>
  );
}
